import { HttpMethod, HttpModel } from '@/Shared/domain'
import { axiosFetch } from '@/Shared/infrastructure'
import {
  getHelpCenterCaseReasons,
  getHelpCenterCaseProducts,
  saveHelpCenterCase,
  getHelpCenterTickets,
  getHelpCenterTicketDetail,
  saveHelpCenterTicketReopen,
  saveHelpCenterLog,
} from '@/Shared/infrastructure/endpoints'
import { HelpCenterRepository } from '../domain/HelpCenterRepository'
import {
  TicketModel,
  CaseProduct,
  SaveCaseRequest,
  TicketHistoryItem,
  TicketDetail,
  SaveCaseReopenRequest,
} from '../domain'

export function createHelpCenterRepository(): HelpCenterRepository {
  return new ApiHelpCenterRepository()
}

export class ApiHelpCenterRepository implements HelpCenterRepository {
  async GetCaseReasons(): Promise<HttpModel<TicketModel[]>> {
    const response = await axiosFetch(getHelpCenterCaseReasons, HttpMethod.GET)

    if (!response.data) {
      return {
        data: [] as TicketModel[],
        meta: response.meta,
      }
    }

    return {
      data: response.data,
      meta: response.meta,
    }
  }
  async GetCaseProducts(): Promise<HttpModel<CaseProduct[]>> {
    const response = await axiosFetch(getHelpCenterCaseProducts, HttpMethod.GET)

    if (!response.data) {
      return {
        data: [] as CaseProduct[],
        meta: response.meta,
      }
    }

    return {
      data: response.data,
      meta: response.meta,
    }
  }

  async SaveCaseRequest(data: SaveCaseRequest): Promise<HttpModel<boolean>> {
    const response = await axiosFetch(saveHelpCenterCase, HttpMethod.POST, data)

    return {
      data: response.data ?? false,
      meta: response.meta,
    }
  }
  async GetTicketHistory(): Promise<HttpModel<TicketHistoryItem[]>> {
    const response = await axiosFetch(getHelpCenterTickets, HttpMethod.GET)

    if (!response.data) {
      return {
        data: [] as TicketHistoryItem[],
        meta: response.meta,
      }
    }

    return {
      data: response.data,
      meta: response.meta,
    }
  }

  async GetTicketDetail(ticketId: string): Promise<HttpModel<TicketDetail>> {
    const response = await axiosFetch(
      `${getHelpCenterTicketDetail}?caseId=${ticketId}`,
      HttpMethod.GET,
    )

    return {
      data: response.data,
      meta: response.meta,
    }
  }

  async SaveTicketReopen(data: SaveCaseReopenRequest): Promise<HttpModel<boolean>> {
    const response = await axiosFetch(saveHelpCenterTicketReopen, HttpMethod.POST, data)

    return {
      data: response.data ?? false,
      meta: response.meta,
    }
  }

  async SaveTicketLog(data: any): Promise<HttpModel<boolean>> {
    const response = await axiosFetch(saveHelpCenterLog, HttpMethod.POST, data)
    return {
      data: response.data ?? false,
      meta: response.meta,
    }
  }


}
